.callout {
	display: flex;
	align-items: center;
	gap: var(--space-3);
	padding: var(--space-3) var(--space-4);
	background: color-mix(in srgb, var(--accent-sage) 12%, var(--surface-card));
	border: 1px solid color-mix(in srgb, var(--accent-sage) 30%, transparent);
	border-radius: var(--radius-md);
	color: var(--ink);
	text-decoration: none;
}

.icon {
	flex-shrink: 0;
	color: var(--accent-sage);
}

.text {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 2px;
}

.label {
	font-size: 0.9rem;
	font-weight: 600;
}

.sub {
	font-size: 0.8rem;
	color: var(--ink-muted);
}

.chevron {
	flex-shrink: 0;
	color: var(--ink-muted);
}
